import axios from 'axios';
import * as general_state from '../store';
import router from '../../router/router';
import sections_list from './sections_list';
import { handleError } from '@/helpers/HandleError';

const state = {
	// Subsections data and structures for section
	subsections_data: {},

	// Subsections relation info table data
	subsections_relation_info_table_data: {},

	// Section level (1., 2. or 3.)
	section_level: '1',

	// Active subsection for section
	active_subsection_id: null,

	// workplantemporary
	staticHTMLTableStringSubsection: ""
};

const getters = {
	subsections_data: state => state.subsections_data,
	subsections_relation_info_table_data: state => state.subsections_relation_info_table_data,
	subsection_data: state => {
		let level = state.section_level;
		let subsection_id = state.active_subsection_id;
		if (!state.subsections_data[level] || !state.subsections_data[level][subsection_id]) return {};
		return state.subsections_data[level][subsection_id];
	},
	section_level: state => state.section_level,
	active_subsection_id: state => state.active_subsection_id,
	staticHTMLTableStringSubsection: state => state.staticHTMLTableStringSubsection
};

const mutations = {
	setLevel: (state, payload) => {
		state.section_level = payload;
		let firstSubsection = state.subsections_data[state.section_level] && Object.values(state.subsections_data[state.section_level])[0];
		state.active_subsection_id = firstSubsection ? firstSubsection.id : null;
	},

	setActiveSubsection: (state, payload) => {
		state.active_subsection_id = payload;
	},

	prepareSubsectionsData: (state, payload) => {
		state.subsections_data = { ...payload.data };
		let level = state.section_level;
		let subsection = state.subsections_data[level] && Object.values(state.subsections_data[level])[0];
		state.active_subsection_id = subsection ? subsection.id : Object.keys(state.subsections_data)[0];
	},

	prepareSubsectionsRelationInfoTableData: (state, payload) => {
		state.subsections_relation_info_table_data = payload.data;
	},

	addSectionPage: (state, payload) => {
		let new_level = Object.keys(state.subsections_data.levels).length + 1;
		state.subsections_data.levels[`level${new_level}`] = {
			name: payload.name,
			enabled: "1",
			level: new_level.toString()
		};
		state.subsections_data[new_level.toString()] = {};
		state.section_level = new_level.toString();
		state.active_subsection_id = null;
	},

	editSectionPage: (state, payload) => {
		state.subsections_data.levels[`level${state.section_level}`].name = payload.name;
	},

	deleteSectionPage: (state, payload) => {
		state.subsections_data = { ...payload.data.data };
		for (let levelkey in state.subsections_data.levels) {
			if (state.subsections_data.levels[levelkey].enabled == "1") {
				state.section_level = state.subsections_data.levels[levelkey].level;
				break;
			}
		}
		let subsection = state.subsections_data[state.section_level] && Object.values(state.subsections_data[state.section_level])[0];
		state.active_subsection_id = subsection ? subsection.id : null;
	},

	addSubsection: (state, payload) => {
		state.subsections_data = { ...payload.data };
		let last = Object.values(state.subsections_data[state.section_level]).pop();
		state.active_subsection_id = last.id;
	},

	editSubsection: (state, payload) => {
		let s = state.subsections_data[state.section_level][state.active_subsection_id];
		Object.assign(s, payload);
	},

	deleteSubsection: (state) => {
		delete state.subsections_data[state.section_level][state.active_subsection_id];
		let first = Object.values(state.subsections_data[state.section_level])[0];
		state.active_subsection_id = first ? first.id : null;
	},

	refreshSubsectionsData: (state, payload) => {
		state.subsections_data = { ...payload.data };
	},

	addSubsectionInfoTableColumn: (state, payload) => {
		state.subsections_data[state.section_level][state.active_subsection_id]['info_table'] = payload.data;
	},

	editSubsectionTableColumn: (state, payload) => {
		let col = state.subsections_data[state.section_level][state.active_subsection_id]['columns'][payload.order_number];
		//if dropdown items is not empty - convert it to array
		if(payload.dropdown_items){
			//from key values order_number and name convert to order nuber as key and name as value
			payload.dropdown_items = Object.fromEntries(Object.entries(payload.dropdown_items).map(([key, value]) => [key, value.name]));
		}
		Object.assign(col, payload);
	},

	editSubsectionInfoTableColumn: (state, payload) => {
		let col = state.subsections_data[state.section_level][state.active_subsection_id]['info_table']['columns'][payload.order_number];
		col.name = payload.name;
		col.description = payload.description;
	},

	deleteSubsectionInfoTableColumn: (state, payload) => {
		state.subsections_data[state.section_level][state.active_subsection_id]['info_table'] = payload.data;
	},

	addSubsectionTableRow: (state, payload) => {
		let level = state.section_level;
		let subsection_id = state.active_subsection_id;
		state.subsections_data[level][subsection_id].data[payload.data.row_id] = payload.data.data;
	},

	addSubsectionInfoTableRow: (state, payload) => {
		let level = state.section_level;
		let subsection_id = state.active_subsection_id;
		state.subsections_data[level][subsection_id].info_table.data[payload.row_id] = { data: payload.data, level: '1' };
	},

	editSubsectionInfoTableRowLevel: (state, payload) => {
		state.subsections_data[state.section_level][state.active_subsection_id].info_table.data[payload.row_id].level = payload.level;
	},

	deleteSubsectionTableRow: (state, payload) => {
		delete state.subsections_data[state.section_level][state.active_subsection_id].data[payload.row_id];
	},

	deleteSubsectionInfoTableRow: (state, payload) => {
		delete state.subsections_data[state.section_level][state.active_subsection_id].info_table.data[payload.row_id];
	},

	uploadTableDataAttachment: (state, payload) => {
		state.subsections_data[state.section_level][state.active_subsection_id].data[payload.row_id][payload.col_id] = {
			name: payload.file_name,
			file_url: payload.file_url,
			file_name: payload.upload_file_name
		};
	},

	deleteTableDataAttachment: (state, payload) => {
		delete state.subsections_data[state.section_level][state.active_subsection_id].data[payload.row_id][payload.col_id];
	},

	staticHTMLTableStringSubsection: (state, payload) => {
		state.staticHTMLTableStringSubsection = payload;
	},

	addSubsectionQuestion: (state, payload) => {
		let s = state.subsections_data[state.section_level][state.active_subsection_id];
		if (!s.questions) s.questions = {};
		s.questions[payload.id] = { ...payload, answer: '' };
		if (payload.mandatory == 1) {
			let section_id = router.currentRoute.value?.params?.section_id;
			let stat = sections_list.state.sections_statistics[section_id];
			stat.stat_count_mandatory++;
			stat.stat_percantage = Math.floor(stat.stat_count_solved_mandatory / stat.stat_count_mandatory * 100);
			stat.stat_count_all += 1;
		}
	},

	editSubsectionQuestion: (state, payload) => {
		Object.assign(state.subsections_data[state.section_level][state.active_subsection_id].questions[payload.id], payload);
	},

	deleteSubsectionQuestion: (state, payload) => {
		let q = state.subsections_data[state.section_level][state.active_subsection_id].questions;
		if (Object.keys(q).length > 1) {
			let deleted_order = q[payload.id].order_number;
			let deleted_pos = q[payload.id].position;
			delete q[payload.id];
			for (let id in q) {
				if (q[id].position == deleted_pos && q[id].order_number > deleted_order) {
					q[id].order_number--;
				}
			}
		} else {
			state.subsections_data[state.section_level][state.active_subsection_id].questions = null;
		}
	},

	saveSubsectionQuestionAnswer: (state, payload) => {
		state.subsections_data[state.section_level][state.active_subsection_id].questions[payload.question_id].answer = payload.value;
	}
};


const actions = {

	// Change section level
	changeLevel: ({ commit }, level) => {
		//timeout needed because question gets focus on auto grow 
		//scroll to subsections
		let element = document.getElementById("subsection_list");
		if (element)
			setTimeout(function () { if (element) element.scrollIntoView({ behavior: "smooth" }) }, 150);

		commit('setLevel', level);
	},

	//Update progressbar
	updateProgressBar: ({ commit }) => {
		let section_id = router.currentRoute.value?.params?.section_id;

		let mandatory_cnt_all = 0;
		let mandatory_cnt_solv = 0;

		let all_cnt_all = 0;
		let all_cnt_solv = 0;

		let all_data = state.subsections_data;

		for (let level in all_data) {
			if (sections_list.state.sections[section_id].levels['level' + level] &&
				sections_list.state.sections[section_id].levels['level' + level].enabled == 1) {

				for (let subs in all_data[level]) {

					//go trough table
					for (let column in all_data[level][subs].columns) {

						let col_id = all_data[level][subs].columns[column].id;

						//exclude lifelong level if disabled
						if (sections_list.state.sections_statistics[section_id]) {
							//Only for mandatory
							if (all_data[level][subs].columns[column].mandatory == 1) {
								for (let row in all_data[level][subs].data) {
									mandatory_cnt_all++;
									const val = all_data[level][subs].data[row][col_id];
									if (val != null && val.toString().trim() !== '')
										mandatory_cnt_solv++;
								}
							}
							//Also for overall stat
							/*else{
								for(let row in all_data[level][subs].data){
									all_cnt_all ++;
									if(all_data[level][subs].data[row][col_id])
										all_cnt_solv ++;
								}
							}*/
						}
					}

					//go trough questions
					for (let question in all_data[level][subs].questions) {
						//exclude lifelong level if disabled
						if (sections_list.state.sections_statistics[section_id] &&
							all_data[level][subs].questions[question].mandatory == 1) {
							//Only for mandatory
							//if(all_data[level][subs].questions[question].mandatory == 1){
							mandatory_cnt_all++;
							const val = all_data[level][subs].questions[question].answer;
							if (val != null && val.toString().trim() !== '')
								mandatory_cnt_solv++;
							//}
						}
					}
				}
			}
		}

		//all_cnt_all += mandatory_cnt_all;
		//all_cnt_solv += mandatory_cnt_solv;

		if (sections_list.state.sections_statistics[section_id])
			commit('editSectionStatistics', {
				section_id: section_id,
				stat_count_mandatory: mandatory_cnt_all,
				stat_count_solved_mandatory: mandatory_cnt_solv,
				stat_count_solved_all: all_cnt_solv,
				stat_count_all: all_cnt_all
			}, { root: true });
	},

	//Update progressbar simple
	updateProgressBarSimple: ({ commit }, payload) => {
		payload.section_id = router.currentRoute.value?.params?.section_id;
		commit('editSectionStatisticsSimple', payload, { root: true });
	},

	//Update progressbar simple for adding row
	updateProgressBarSimpleAddRow: ({ commit }, payload) => {
		payload.section_id = router.currentRoute.value?.params?.section_id;
		commit('editSectionStatisticsSimpleAddRow', payload, { root: true });
	},

	// Change active subsection
	changeActiveSubsection: ({ commit }, subsection_id) => {
		//timeout needed because question gets focus on auto grow 
		//scroll to subsections
		let element = document.getElementById("subsection_list");
		setTimeout(function () { if (element) element.scrollIntoView({ behavior: "smooth" }) }, 150);

		commit('setActiveSubsection', subsection_id);
	},

	// Prepare subsections data based on section id
	prepareSubsectionsData: ({ commit }, payload) => {
		commit('showModalWorking');
		axios.get('?module=sections&action=get_details&faculty=' + general_state.state.faculty.id + '&section_id=' + payload)
			.then(
				res => {
					if (res.data.error) {
						commit('hideModalWorking');
						var error = res.data.error ? res.data.error : payload.data;
						commit('showModal', { component: 'ModalError', data: error })
					}
					else {
						commit('prepareSubsectionsData', res);
						commit('hideModalWorking');

						//timeout needed because question gets focus on auto grow 
						//scroll to subsections
						let element = document.getElementById("section_title");
						setTimeout(function () { if (element) element.scrollIntoView({ behavior: "smooth" }) }, 100);
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Prepare subsections relation info table data based on section id
	prepareSubsectionsRelationInfoTableData: ({ commit }, payload) => {
		axios.get('?module=subsections&action=get_relation_info_tables&faculty=' + general_state.state.faculty.id + '&section_id=' + payload)
			.then(
				res => {
					if (res.data.error) {
						commit('hideModalWorking');
						var error = res.data.error ? res.data.error : payload.data;
						commit('showModal', { component: 'ModalError', data: error })
					}
					else {
						commit('prepareSubsectionsRelationInfoTableData', res);
						commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Add new page 
	addSectionPage: ({ commit }, payload) => {
		commit('showModalWorking');

		let section_id = router.currentRoute.value?.params?.section_id;
		axios.post('?module=sections&action=add_page&section_id=' + section_id + '&faculty=' + general_state.state.faculty.id, payload)
			.then(
				res => {
					if (!res.data.success) {
						commit('hideModalWorking');
						var error = res.data.error ? res.data.error : payload.data;
						commit('showModal', { component: 'ModalError', data: error })
					}
					else {
						commit('addSectionPage', payload);
						commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Edit existing page 
	editSectionPage: ({ commit }, payload) => {
		commit('showModalWorking');

		let section_id = router.currentRoute?.value?.params?.section_id;
		axios.post('?module=sections&action=edit_page&section_id=' + section_id + '&level=' + state.section_level, payload)
			.then(
				res => {
					if (!res.data.success) {
						commit('hideModalWorking');
						var error = res.data.error ? res.data.error : payload.data;
						commit('showModal', { component: 'ModalError', data: error })
					}
					else {
						commit('editSectionPage', payload);
						commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Edit existing page 
	deleteSectionPage: ({ commit, dispatch }, payload) => {
		commit('showModalWorking');

		let section_id = router.currentRoute.value?.params?.section_id;
		axios.post('?module=sections&action=delete_page&section_id=' + section_id + '&faculty=' + general_state.state.faculty.id + '&level=' + state.section_level)
			.then(
				res => {
					if (!res.data.success) {
						commit('hideModalWorking');
						var error = res.data.error ? res.data.error : payload.data;
						commit('showModal', { component: 'ModalError', data: error })
					}
					else {
						commit('deleteSectionPage', res);
						dispatch('updateProgressBar');
						commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Add new subsection 
	addSubsection: ({ commit }, payload) => {
		commit('showModalWorking');
		axios.post('?module=subsections&action=add_subsection&section_id=' + payload.section_id + '&faculty=' + general_state.state.faculty.id + '&level=' + state.section_level, payload)
			.then(
				res => {
					if (!res.data.success) {
						commit('hideModalWorking');
						var error = res.data.error ? res.data.error : payload.data;
						commit('showModal', { component: 'ModalError', data: error })
					}
					else {
						commit('addSubsection', res);
						commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Edit existing subsection 
	editSubsection: ({ commit }, payload) => {
		commit('showModalWorking');
		axios.post('?module=subsections&action=edit_subsection&subsection_id=' + state.active_subsection_id, payload)
			.then(
				res => {
					if (!res.data.success) {
						commit('hideModalWorking');
						var error = res.data.error ? res.data.error : payload.data;
						commit('showModal', { component: 'ModalError', data: error })
					}
					else {
						commit('editSubsection', payload);
						commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Edit existing subsection 
	deleteSubsection: ({ commit, dispatch }, payload) => {
		commit('showModalWorking');
		axios.post('?module=subsections&action=delete_subsection&subsection_id=' + state.active_subsection_id)
			.then(
				res => {
					if (!res.data.success) {
						commit('hideModalWorking');
						var error = res.data.error ? res.data.error : payload.data;
						commit('showModal', { component: 'ModalError', data: error })
					}
					else {
						commit('deleteSubsection');
						dispatch('updateProgressBar');
						commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Add new column 
	addSubsectionTableColumn: ({ commit, dispatch }, payload) => {
		commit('showModalWorking');
		axios.post('?module=subsection_table&action=add_column&faculty=' + general_state.state.faculty.id + '&section_id=' + payload.section_id + '&subsection_id=' + state.active_subsection_id, payload)
			.then(
				res => {
					if (!res.data.success) {
						commit('hideModalWorking');
						var error = res.data.error ? res.data.error : payload.data;
						commit('showModal', { component: 'ModalError', data: error })
					}
					else {
						commit('refreshSubsectionsData', res);
						dispatch('updateProgressBar');
						commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Add new column in info table
	addSubsectionInfoTableColumn: ({ commit }, payload) => {
		commit('showModalWorking');
		axios.post('?module=subsection_info_table&action=add_column&subsection_id=' + state.active_subsection_id, payload)
			.then(
				res => {
					if (!res.data.success) {
						commit('hideModalWorking');
						var error = res.data.error ? res.data.error : payload.data;
						commit('showModal', { component: 'ModalError', data: error })
					}
					else {
						commit('addSubsectionInfoTableColumn', res.data);
						commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},


	// Edit new column 
	editSubsectionTableColumn: ({ commit, dispatch }, payload) => {
		commit('showModalWorking');
		axios.post('?module=subsection_table&action=edit_column&col_id=' + payload.column_id, payload)
			.then(
				res => {
					if (!res.data.success) {
						commit('hideModalWorking');
						var error = res.data.error ? res.data.error : payload;
						commit('showModal', { component: 'ModalError', data: error })
					}
					else {
						commit('editSubsectionTableColumn', payload);
						commit('hideModalWorking');
						dispatch('updateProgressBar');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Edit info table column 
	editSubsectionInfoTableColumn: ({ commit, dispatch }, payload) => {
		commit('showModalWorking');
		axios.post('?module=subsection_info_table&action=edit_column&subsection_id=' + state.active_subsection_id + '&col_id=' + payload.column_id, payload)
			.then(
				res => {
					if (!res.data.success) {
						commit('hideModalWorking');
						var error = res.data.error ? res.data.error : payload;
						commit('showModal', { component: 'ModalError', data: error })
					}
					else {
						commit('editSubsectionInfoTableColumn', payload);
						commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Delete new column 
	deleteSubsectionTableColumn: ({ commit, dispatch }, payload) => {
		commit('showModalWorking');
		axios.post('?module=subsection_table&action=delete_column&faculty=' + general_state.state.faculty.id + '&section_id=' + payload.section_id + '&subsection_id=' + state.active_subsection_id + '&col_id=' + payload.column_id)
			.then(
				res => {
					if (!res.data.success) {
						commit('hideModalWorking');
						var error = res.data.error ? res.data.error : payload;
						commit('showModal', { component: 'ModalError', data: error })
					}
					else {
						commit('refreshSubsectionsData', res);
						dispatch('updateProgressBar');
						commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Delete info table column 
	deleteSubsectionInfoTableColumn: ({ commit }, payload) => {
		commit('showModalWorking');
		axios.post('?module=subsection_info_table&action=delete_column&subsection_id=' + state.active_subsection_id + '&col_id=' + payload.column_id)
			.then(
				res => {
					if (!res.data.success) {
						commit('hideModalWorking');
						var error = res.data.error ? res.data.error : payload;
						commit('showModal', { component: 'ModalError', data: error })
					}
					else {
						commit('deleteSubsectionInfoTableColumn', res.data);
						commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Add info table row 
	addSubsectionInfoTableRow: ({ commit }, payload) => {
		axios.post('?module=subsection_info_table&action=add_row&subsection_id=' + state.active_subsection_id)
			.then(
				res => {
					if (!res.data.success) {
						var error = res.data.error ? res.data.error : payload.data;
						commit('showModal', { component: 'ModalError', data: error })
					}
					else {
						commit('addSubsectionInfoTableRow', res.data);
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Change info table row level
	editSubsectionInfoTableRowLevel: ({ commit }, payload) => {
		axios.post('?module=subsection_info_table&action=edit_row_level&row_id=' + payload.row_id + '&level=' + payload.level)
			.then(
				res => {
					if (!res.data.success) {
						var error = res.data.error ? res.data.error : payload.data;
						commit('showModal', { component: 'ModalError', data: error })
					}
					else {
						commit('editSubsectionInfoTableRowLevel', payload);
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Add new row 
	addSubsectionTableRow: ({ commit, dispatch }, payload) => {
		axios.post('?module=subsection_table&action=add_row&faculty=' + general_state.state.faculty.id + '&subsection_id=' + state.active_subsection_id)
			.then(
				res => {
					if (!res.data.success) {
						var error = res.data.error ? res.data.error : payload.data;
						commit('showModal', { component: 'ModalError', data: error })
					}
					else {
						commit('addSubsectionTableRow', res);
						dispatch('updateProgressBarSimpleAddRow', payload);
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Clone row in subsection table, usually used from relations info table
	cloneRowInSubsectionTable: ({ commit, dispatch }, payload) => {
		axios.post('?module=subsection_table&action=clone_row&faculty=' + general_state.state.faculty.id, payload)
			.then(
				res => {
					if (!res.data.success) {
						var error = res.data.error ? res.data.error : payload.data;
						commit('showModal', { component: 'ModalError', data: error })
					}
					else {
						if (res.data.deleted_row_id) {
							commit('deleteSubsectionTableRow', { row_id: res.data.deleted_row_id });
						}
						commit('addSubsectionTableRow', res);
						dispatch('updateProgressBar');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Delete row
	deleteSubsectionTableRow: ({ commit, dispatch }, payload) => {
		axios.post('?module=subsection_table&action=delete_row&row_id=' + payload.row_id)
			.then(
				res => {
					if (!res.data.success) {
						var error = res.data.error ? res.data.error : payload.data;
						commit('showModal', { component: 'ModalError', data: error })
					}
					else {
						commit('deleteSubsectionTableRow', payload);
						dispatch('updateProgressBar', payload);
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Delete info table row
	deleteSubsectionInfoTableRow: ({ commit }, payload) => {
		axios.post('?module=subsection_info_table&action=delete_row&row_id=' + payload.row_id)
			.then(
				res => {
					if (!res.data.success) {
						var error = res.data.error ? res.data.error : payload.data;
						commit('showModal', { component: 'ModalError', data: error })
					}
					else {
						commit('deleteSubsectionInfoTableRow', payload);
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Save data 
	saveSectionData: ({ commit, dispatch }, payload) => {
		commit('showModalWorking');

		axios.post('?module=subsection_table&action=save_data&faculty=' + general_state.state.faculty.id + '&section_id=' + payload.section_id, payload)
			.then(
				res => {
					if (!res.data.success) {
						var error = res.data.error ? res.data.error : payload.data;
						commit('hideModalWorking');
						commit('showModal', { component: 'ModalError', data: error })
					}
					else {
						dispatch('prepareSectionsStat');
						commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Update cell
	updateCell: ({ commit, dispatch }, payload) => {
		axios.post('?module=subsection_table&action=update_cell', payload)
			.then(
				res => {
					if (!res.data.success) {
						var error = res.data.error ? res.data.error : 'Nepravilen vnos';
						commit('showModal', { component: 'ModalError', data: error })
					}
					else {
						//dispatch('updateProgressBar');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Update info table cell
	updateInfoTableCell: ({ commit }, payload) => {
		axios.post('?module=subsection_info_table&action=update_cell', payload)
			.then(
				res => {
					if (!res.data.success) {
						var error = res.data.error ? res.data.error : 'Nepravilen vnos';
						commit('showModal', { component: 'ModalError', data: error })
					}
					else {
						//dispatch('updateProgressBar');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Delete attachment
	deleteTableDataAttachment: ({ commit, dispatch }, payload) => {
		commit('showModalWorking');
		axios.post('?module=upload&action=delete_table_upload&row_id=' + payload.row_id + '&col_id=' + payload.col_id)
			.then(
				res => {
					if (!res.data.success) {
						var error = res.data.error ? res.data.error : formData;
						commit('hideModalWorking');
						commit('showModal', { component: 'ModalError', data: error })
					}
					else {
						commit('deleteTableDataAttachment', payload);
						dispatch('updateProgressBarSimple', { mandatory: payload.mandatory, edit: -1 });
						commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},


	// Upload attachment for data table
	uploadTableDataAttachment: ({ commit, dispatch }, payload) => {
		commit('showModalWorking');

		let formData = new FormData();
		formData.append('file', payload.file);
		formData.set('name', payload.file_name);

		axios.post('?module=upload&action=upload_table_file&row_id=' + payload.row_id + '&col_id=' + payload.col_id, formData)
			.then(
				res => {
					if (!res.data.success) {
						var error = res.data.error ? res.data.error : res.data;
						commit('hideModalWorking');
						commit('showModal', { component: 'ModalError', data: error })
					}
					else {
						if (res.data.upload_url && res.data.upload_file_name) {
							payload.file_url = res.data.upload_url;
							payload.upload_file_name = res.data.upload_file_name;
						}
						else
							commit('showModal', { component: 'ModalError', data: 'Upload URL or name missing in response!' })

						commit('uploadTableDataAttachment', payload);
						dispatch('updateProgressBarSimple', { mandatory: payload.mandatory, edit: 1 });
						commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Get string of static html table
	getStaticHTMLTableString: ({ commit }, payload) => {
		axios.get('?module=subsections&action=get_static_table&name=' + payload.file_name + '&section_id=' + payload.section_id)
			.then(
				res => {
					if (payload.table == 'faculty_sub') {
						if (res.data && res.data.data)
							commit('staticHTMLTableStringSubsection', res.data.data);
						else
							commit('staticHTMLTableStringSubsection', '');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Export subsection table for import data
	exportSubsectionTableImportFile: ({ commit, dispatch }) => {
		commit('showModalWorking');
		axios.get('?module=export&action=get_subsection_table_import_file&subsection_id=' + state.active_subsection_id + '&faculty=' + general_state.state.faculty.id)
			.then(
				res => {
					if (!res.data.success) {
						commit('hideModalWorking');
						var error = res.data.error ? res.data.error : 'Napaka';
						commit('showModal', { component: 'ModalError', data: error })
					}
					else {
						commit('hideModalWorking');
						dispatch('downloadFile', { url: res.data.export_link, filename: res.data.export_filename });
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Import subsection table from file
	importDataSubsectionTable: ({ commit, dispatch }, payload) => {

		let level = state.section_level;
		let subsection_id = state.active_subsection_id;

		commit('showModalWorking');

		let formData = new FormData();
		formData.append('file', payload.file);

		let section_id = router.currentRoute.value?.params?.section_id;

		axios.post('?module=subsection_table&action=import_subsection_table_data&subsection_id=' + state.active_subsection_id +
			'&faculty=' + general_state.state.faculty.id + '&section_id=' + section_id, formData)
			.then(
				res => {
					if (!res.data.success) {
						commit('hideModalWorking');
						var error = res.data.error ? res.data.error : 'Napaka pri uvozu podatkov';

						if (res.data.error == 'bad_data')
							commit('showModal', { component: 'ModalError', data: 'Struktura in/ali podatki v datoteki se ne ujemajo s tabelo podpodročja!' })
						else
							commit('showModal', { component: 'ModalError', data: error })
					}
					else {
						commit('refreshSubsectionsData', res);
						dispatch('updateProgressBar');
						commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Export section data
	exportSectionData: ({ commit, dispatch }, payload) => {
		commit('showModalWorking');
		axios.get('?module=export&action=get_section_export&section_id=' + payload.section_id + '&format=' + payload.format + '&faculty=' + general_state.state.faculty.id)
			.then(
				res => {
					if (!res.data.success) {
						commit('hideModalWorking');
						var error = res.data.error ? res.data.error : payload.data;
						commit('showModal', { component: 'ModalError', data: error })
					}
					else {
						commit('hideModalWorking');
						dispatch('downloadFile', { url: res.data.export_link, filename: res.data.export_filename });
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Export united measures section data
	exportUnitedMeasuresSectionData: ({ commit, dispatch }, payload) => {
		commit('showModalWorking');
		axios.get('?module=export&action=get_ukrepi_section_export&section_id=' + payload.section_id + '&format=' + payload.format + '&faculty=' + general_state.state.faculty.id)
			.then(
				res => {
					if (!res.data.success) {
						commit('hideModalWorking');
						var error = res.data.error ? res.data.error : payload.data;
						commit('showModal', { component: 'ModalError', data: error })
					}
					else {
						commit('hideModalWorking');
						dispatch('downloadFile', { url: res.data.export_link, filename: res.data.export_filename });
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Copy table to all faculties
	CopyTableOverrideData: ({ commit }) => {
		commit('showModalWorking');
		axios.get('?module=subsection_table&action=save_predefined_data&subsection_id=' + state.active_subsection_id + '&faculty=' + general_state.state.faculty.id)
			.then(
				res => {
					if (!res.data.success) {
						commit('hideModalWorking');
						var error = res.data.error ? res.data.error : res.data;
						commit('showModal', { component: 'ModalError', data: error })
					}
					else {
						commit('hideModalWorking');
						commit('showModal', { component: 'ModalWarning', data: { title: "Vsebina tabele kopirana", description: "Vsebina tabele podpodročja se je uspešno kopirala v ostale članice" } })
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Add question in subsection
	addSubsectionQuestion: ({ commit }, payload) => {
		commit('showModalWorking');
		axios.post('?module=subsection_question&action=add_question&subsection_id=' + state.active_subsection_id, payload)
			.then(
				res => {
					if (res.data.error) {
						commit('hideModalWorking');
						commit('showModal', { component: 'ModalError', data: res.data.error })
					}
					else {
						payload.id = res.data.question_id;
						commit('addSubsectionQuestion', payload);
						commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Edit question in subsection
	editSubsectionQuestion: ({ commit, dispatch }, payload) => {
		commit('showModalWorking');
		axios.post('?module=subsection_question&action=edit_question&question_id=' + payload.id, payload)
			.then(
				res => {
					if (res.data.error) {
						commit('hideModalWorking');
						commit('showModal', { component: 'ModalError', data: res.data.error })
					}
					else {
						commit('editSubsectionQuestion', payload);
						dispatch('updateProgressBar');
						commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Delete question in subsection
	deleteSubsectionQuestion: ({ commit, dispatch }, payload) => {
		commit('showModalWorking');
		axios.get('?module=subsection_question&action=delete_question&question_id=' + payload.id)
			.then(
				res => {
					if (res.data.error) {
						commit('hideModalWorking');
						commit('showModal', { component: 'ModalError', data: res.data.error })
					}
					else {
						commit('deleteSubsectionQuestion', payload);
						dispatch('updateProgressBar');
						commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Save answer
	saveSubsectionQuestionAnswer: ({ commit, dispatch }, payload) => {
		//commit('showModalWorking');
		axios.post('?module=subsection_question&action=save_question_answer&question_id=' + payload.question_id + '&faculty=' + general_state.state.faculty.id, payload)
			.then(
				res => {
					if (res.data.error) {
						//commit('hideModalWorking');
						commit('showModal', { component: 'ModalError', data: res.data.error })
					}
					else {
						commit('saveSubsectionQuestionAnswer', payload);
						dispatch('updateProgressBar', payload);
						//commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Count column data
	countColumnData: ({ commit }, payload) => {
		return new Promise((resolve, reject) => {
			axios.get('?module=subsection_table&action=count_column_data&col_id=' + payload.col_id)
				.then(res => {
					if (!res.data.success) {
						var error = res.data.error ? res.data.error : 'Napaka';
						commit('showModal', { component: 'ModalError', data: error });
						reject(error);
					} else {
						// return the data directly
						resolve(res.data);
					}
				})
				.catch(error => {
					handleError(commit, error);
					reject(error);
				});
		});
	},

	// Get files  package for whole column (and all faculties if specified)
	exportFilesColumn: ({ commit, dispatch }, payload) => {
		commit('showModalWorking');
		payload.faculty = general_state.state.faculty.id;

		axios.post('?module=upload&action=get_subsection_all_files_by_column', payload)
			.then(
				res => {
					if (!res.data.success) {
						var error = res.data.error ? res.data.error : "Napaka";
						commit('hideModalWorking');
						if (error == "no_files") {
							commit('showModal', {
								component: 'ModalWarning',
								data: { title: "Ni datotek", description: "Za ta stolpec še ni naloženih datotek" }
							})
						}
						else if (error == "too_big") {
							commit('showModal', {
								component: 'ModalWarning',
								data: { title: "Prenos prevelik", description: "Omejitev prenosa datoteke je 114MB. Poskusite ponovno s prenosom manjših/razdeljenih paketov." }
							})
						}
						else
							commit('showModal', { component: 'ModalError', data: error })
					}
					else {
						commit('hideModalWorking');
						dispatch('downloadFile', { url: res.data.download_link, filename: 'datoteke.zip' });
					}
				}
			)
			.catch(error => handleError(commit, error));
	},
};


export default {
	state,
	getters,
	actions,
	mutations
}